export enum HistoryConfigStatus {
    NOT_AVAILABLE = 'NOT_AVAILABLE',
    BLOB_UPLOADED = 'BLOB_UPLOADED',
    VALIDATION_COMPLETED = 'VALIDATION_COMPLETED',
    VALIDATION_IN_PROGRESS = 'VALIDATION_IN_PROGRESS',
    VALIDATION_COMPLETED_WITH_ERRORS = 'VALIDATION_COMPLETED_WITH_ERRORS',
    MODEL_UPDATE_FAILED = 'MODEL_UPDATE_FAILED',
    ERROR = 'ERROR',
    VALIDATION_COMPLETED_RETRIEVAL_COMPLETED = 'VALIDATION_COMPLETED_RETRIEVAL_COMPLETED',
    VALIDATION_COMPLETED_RETRIEVAL_FAILED = 'VALIDATION_COMPLETED_RETRIEVAL_FAILED'
  }
